(function () {
  'use strict';

  var section = document.querySelector('[data-withdrawal-section]');
  if (!section) return;

  var form = section.querySelector('#WithdrawalForm');
  if (!form) return;

  var endpoint = (section.getAttribute('data-endpoint') || '').trim();
  var locale = section.getAttribute('data-locale') || 'de';
  var isEnglish = locale.toLowerCase().indexOf('en') === 0;
  var detailsStep = section.querySelector('[data-withdrawal-step="details"]');
  var reviewStep = section.querySelector('[data-withdrawal-step="review"]');
  var successStep = section.querySelector('[data-withdrawal-success]');
  var errorBox = section.querySelector('[data-withdrawal-error]');
  var itemsWrap = section.querySelector('[data-withdrawal-items-wrap]');
  var itemsInput = section.querySelector('[data-withdrawal-items]');
  var confirmButton = section.querySelector('[data-withdrawal-confirm]');
  var state = 'details';
  var submissionId = null;
  var receiptStorageKey = 'strapklub.withdrawal.receipt';

  function selectedScope() {
    return form.querySelector('[data-withdrawal-scope]:checked');
  }

  function isPartial() {
    var scope = selectedScope();
    return scope && scope.getAttribute('data-withdrawal-scope') === 'partial';
  }

  function setItemsVisibility() {
    var partial = isPartial();
    itemsWrap.hidden = !partial;
    itemsInput.required = partial;
    if (!partial) itemsInput.setCustomValidity('');
  }

  function setActiveStep(stepNumber) {
    section.querySelectorAll('[data-step-indicator]').forEach(function (item) {
      item.classList.toggle('is-active', item.getAttribute('data-step-indicator') === String(stepNumber));
    });
  }

  function value(selector) {
    var field = section.querySelector(selector);
    return field ? field.value.trim() : '';
  }

  function setText(selector, text) {
    var node = section.querySelector(selector);
    if (node) node.textContent = text;
  }

  function formatReceiptTime(isoString) {
    var date = new Date(isoString);
    if (Number.isNaN(date.getTime())) date = new Date();

    var datePart = date.toLocaleDateString(isEnglish ? 'en-GB' : 'de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'Europe/Berlin'
    });
    var timePart = date.toLocaleTimeString(isEnglish ? 'en-GB' : 'de-DE', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Europe/Berlin'
    });

    return isEnglish
      ? datePart + ' at ' + timePart
      : datePart + ' um ' + timePart + ' Uhr';
  }

  function storeReceipt(data) {
    try {
      window.sessionStorage.setItem(receiptStorageKey, JSON.stringify({
        submittedAt: data.submittedAt,
        email: data.email
      }));
    } catch (error) {
      // The server-rendered receipt time remains as a fallback.
    }
  }

  function readReceipt() {
    try {
      var receipt = JSON.parse(window.sessionStorage.getItem(receiptStorageKey) || 'null');
      return receipt && receipt.submittedAt ? receipt : null;
    } catch (error) {
      return null;
    }
  }

  function clearReceipt() {
    try {
      window.sessionStorage.removeItem(receiptStorageKey);
    } catch (error) {
      // Nothing to clear.
    }
  }

  function renderReceipt(container, data) {
    if (!container || !data) return;
    var timestampNode = container.querySelector('[data-success-timestamp]');
    var emailNode = container.querySelector('[data-success-email]');
    if (timestampNode) timestampNode.textContent = formatReceiptTime(data.submittedAt);
    if (emailNode && data.email) emailNode.textContent = data.email;
  }

  function declarationText(data) {
    if (isEnglish) {
      return 'I hereby withdraw from the contract identified by order ' + data.orderNumber +
        (data.scope === 'partial' ? ' with regard to the following items: ' + data.items + '.' : ' in its entirety.') +
        ' Name: ' + data.name + '. Receipt confirmation to: ' + data.email + '.';
    }
    return 'Hiermit widerrufe ich den mit der Bestellung ' + data.orderNumber + ' geschlossenen Vertrag ' +
      (data.scope === 'partial' ? 'hinsichtlich folgender Artikel: ' + data.items + '.' : 'vollständig.') +
      ' Name: ' + data.name + '. Eingangsbestätigung an: ' + data.email + '.';
  }

  function formDataObject() {
    if (!submissionId) {
      submissionId = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    }
    var scope = isPartial() ? 'partial' : 'full';
    var data = {
      submissionId: submissionId,
      name: value('#WithdrawalName'),
      orderNumber: value('#WithdrawalOrder'),
      email: value('#WithdrawalEmail'),
      scope: scope,
      items: scope === 'partial' ? value('#WithdrawalItems') : '',
      locale: locale,
      submittedAt: new Date().toISOString(),
      source: window.location.href,
      website: value('#WithdrawalWebsite')
    };
    data.declaration = declarationText(data);
    return data;
  }

  function showReview() {
    setItemsVisibility();
    if (!form.reportValidity()) return;

    var data = formDataObject();
    setText('[data-review-name]', data.name);
    setText('[data-review-order]', data.orderNumber);
    setText('[data-review-email]', data.email);
    setText('[data-review-scope]', data.scope === 'partial'
      ? (isEnglish ? 'Individual items' : 'Einzelne Artikel')
      : (isEnglish ? 'Entire order' : 'Gesamte Bestellung'));
    setText('[data-review-items]', data.items);
    setText('[data-review-declaration]', data.declaration);
    var row = section.querySelector('[data-review-items-row]');
    if (row) row.hidden = data.scope !== 'partial';

    detailsStep.hidden = true;
    reviewStep.hidden = false;
    errorBox.hidden = true;
    state = 'review';
    setActiveStep(2);
    reviewStep.setAttribute('tabindex', '-1');
    reviewStep.focus();
  }

  function showDetails() {
    reviewStep.hidden = true;
    detailsStep.hidden = false;
    errorBox.hidden = true;
    state = 'details';
    setActiveStep(1);
    section.querySelector('#WithdrawalName').focus();
  }

  function showError(message) {
    errorBox.textContent = message;
    errorBox.hidden = false;
    errorBox.focus();
  }

  var postedSuccessStep = section.querySelector('[data-withdrawal-posted-success]');
  if (postedSuccessStep) {
    var storedReceipt = readReceipt();
    renderReceipt(postedSuccessStep, {
      submittedAt: storedReceipt ? storedReceipt.submittedAt : new Date().toISOString(),
      email: storedReceipt ? storedReceipt.email : ''
    });
    clearReceipt();
    postedSuccessStep.focus();
    return;
  }

  section.querySelectorAll('[data-withdrawal-scope]').forEach(function (input) {
    input.addEventListener('change', setItemsVisibility);
  });

  section.querySelector('[data-withdrawal-review]').addEventListener('click', showReview);
  section.querySelector('[data-withdrawal-back]').addEventListener('click', showDetails);

  form.addEventListener('submit', function (event) {
    if (state === 'native-submit') return;
    event.preventDefault();

    if (state === 'details') {
      showReview();
      return;
    }

    if (!endpoint) {
      var fallbackData = formDataObject();
      section.querySelector('[data-withdrawal-timestamp]').value = fallbackData.submittedAt;
      section.querySelector('[data-withdrawal-declaration]').value = fallbackData.declaration;
      storeReceipt(fallbackData);
      confirmButton.disabled = true;
      confirmButton.setAttribute('aria-busy', 'true');
      state = 'native-submit';
      form.requestSubmit();
      return;
    }

    var data = formDataObject();
    var timestampField = section.querySelector('[data-withdrawal-timestamp]');
    var declarationField = section.querySelector('[data-withdrawal-declaration]');
    timestampField.value = data.submittedAt;
    declarationField.value = data.declaration;
    confirmButton.disabled = true;
    confirmButton.setAttribute('aria-busy', 'true');
    errorBox.hidden = true;

    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json().catch(function () { return {}; });
    }).then(function (result) {
      reviewStep.hidden = true;
      successStep.hidden = false;
      renderReceipt(successStep, {
        submittedAt: result.receivedAt || data.submittedAt,
        email: data.email
      });
      if (result.reference) {
        setText('[data-success-reference]', result.reference);
        section.querySelector('[data-success-reference-wrap]').hidden = false;
      }
      successStep.focus();
      form.reset();
      submissionId = null;
    }).catch(function () {
      showError(isEnglish
        ? 'The withdrawal could not be sent. Please try again or email info@strapklub.com.'
        : 'Der Widerruf konnte nicht übermittelt werden. Bitte versuche es erneut oder sende ihn per E-Mail an info@strapklub.com.');
      confirmButton.disabled = false;
    }).finally(function () {
      confirmButton.removeAttribute('aria-busy');
    });
  });

  setItemsVisibility();
}());
